import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'reactstrap';

const PatientDoctorsInfo = ({ doctor, clinic, agency }) => (
  <Table
    className="patient-doctor-info"
    borderless
    border="0"
    cellSpacing="0"
    cellPadding="0"
  >
    <thead>
      <tr>
        <th className="table-col-width">Physician</th>
        <th>Details</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>
          <strong>Doctor</strong>
        </td>
        <td>
          <span>{`${doctor.firstName} ${doctor.lastName}`}</span>
          <span>{doctor.professionType}</span>
          {doctor.status === 'inactive' && (
            <span className="error-message">
              *the doctor is currently inactive
            </span>
          )}
        </td>
      </tr>
      <tr>
        <td>
          <strong>Clinic</strong>
        </td>
        <td>
          {clinic.legalName && (
            <>
              <span className="subheader">Legal Name:</span>
              <span>{clinic.legalName}</span>
            </>
          )}
          {clinic.email && (
            <>
              <span className="subheader">Email:</span>
              <span>{clinic.email}</span>
            </>
          )}
          {clinic.phone && (
            <>
              <span className="subheader">Phone Number:</span>
              <span>{clinic.phone}</span>
            </>
          )}
          {clinic.fax && (
            <>
              <span className="subheader">Fax:</span>
              <span>{clinic.fax}</span>
            </>
          )}
          {clinic.officeHours && (
            <>
              <span className="subheader">Office Hours:</span>
              <span>{clinic.officeHours}</span>
            </>
          )}
          {(clinic.addressLine1 || clinic.addressLine2) && (
            <>
              <span className="subheader">Addresses:</span>
              <span>
                {clinic.addressLine1} {clinic.addressLine2}
              </span>
            </>
          )}
          {clinic.city && (
            <>
              <span className="subheader">City:</span>
              <span>{clinic.city}</span>
            </>
          )}
          {clinic.state && (
            <>
              <span className="subheader">State:</span>
              <span>{clinic.state}</span>
            </>
          )}
          {clinic.zip && (
            <>
              <span className="subheader">Zip:</span>
              <span>{clinic.zip}</span>
            </>
          )}
        </td>
      </tr>
      <tr>
        <td>
          <strong>CCM Clinical Manager</strong>
        </td>
        <td>
          {agency.legalName && (
            <>
              <span className="subheader">Legal Name:</span>
              <span>{agency.legalName}</span>
            </>
          )}
          {(agency.addressLine1 || agency.addressLine2) && (
            <>
              <span className="subheader">Addresses:</span>
              <span>
                {agency.addressLine1} {agency.addressLine2}
              </span>
            </>
          )}
          {agency.city && (
            <>
              <span className="subheader">City:</span>
              <span>{agency.city}</span>
            </>
          )}
          {agency.state && (
            <>
              <span className="subheader">State:</span>
              <span>{agency.state}</span>
            </>
          )}
          <span className="subheader">Office:</span>
          <span>{agency.phone}</span>
          <span className="subheader">Fax:</span>
          <span>{agency.fax}</span>
        </td>
      </tr>
    </tbody>
  </Table>
);

PatientDoctorsInfo.propTypes = {
  doctor: PropTypes.shape(),
  clinic: PropTypes.shape(),
  agency: PropTypes.shape(),
};

export default PatientDoctorsInfo;
